// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.staging.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  environmentName: 'dev',
  webSocketUrl: 'wss://cgnadyrnq4.execute-api.us-west-2.amazonaws.com/dev',
  accountServiceUrl: 'https://api.dev.mybudsense.com/account',
  deviceServiceUrl: 'https://api.dev.mybudsense.com/device',
  imageServiceUrl: 'https://api.dev.mybudsense.com/image',
  mainServiceUrl: 'https://api.dev.mybudsense.com/main',
  menuServiceUrl: 'https://api.dev.mybudsense.com/menu',
  productServiceUrl: 'https://api.dev.mybudsense.com/product',
  templateServiceUrl: 'https://api.dev.mybudsense.com/template',
  firebaseConfig: {
    apiKey: 'AIzaSyDjwZQn64i4YkBO77AP9oEqhPwhOMH5GNI',
    authDomain: 'budsense-display-staging.firebaseapp.com',
    projectId: 'budsense-display-staging',
    storageBucket: 'budsense-display-staging.appspot.com',
    messagingSenderId: '152874063248',
    appId: '1:152874063248:web:745fb6eb6df60747918f15',
    measurementId: 'G-JQL0RL3YEY'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
